module.exports = __webpack_public_path__ + "StagSans-Book-Cy-Gr-Web.woff2";